import {Component} from '@angular/core';
import {DeliveryTimeSlotData} from "../../../interfaces/delivery-time-slot";
import {hasPermissionOnEntity,} from "../../../utils/global-functions-and-types";
import {ResponsiveService} from "../../../services/responsive.service";
import {SnackService} from "../../../services/snack.service";
import {DialogsService} from "../../../services/dialogs.service";
import {UtilsService} from "../../../services/utils.service";
import {EMPTY, Observable, of, switchMap, tap} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {catchError} from "rxjs/operators";
import {GeneralDialogComponent} from "../../../utils/shared-components/general-dialog/general-dialog.component";
import {BaseTableComponent} from "../../../utils/shared-components/base-table/base-table.component";
import {DeliveryTimeSlotsFormComponent} from "../delivery-time-slots-form/delivery-time-slots-form.component";
import {Constants} from "../../../utils/constants";
import {DeliveryTimeSlotsService} from "../../../services/delivery-time-slots.service";

@Component({
  selector: 'aw-delivery-time-slots-table',
  templateUrl: './delivery-time-slots-table.component.html',
  styleUrls: ['./delivery-time-slots-table.component.scss']
})
export class DeliveryTimeSlotsTableComponent extends BaseTableComponent<DeliveryTimeSlotData> {

  constructor(private deliveryTimeSlotsService: DeliveryTimeSlotsService,
              public responsiveService: ResponsiveService,
              public override snackService: SnackService,
              protected override dialogService: DialogsService,
              protected override utilsService: UtilsService,
  ) {

    let deleteFunction =
      (companyId: number, deliveryTimeSlotId: number): Observable<void> =>
        deliveryTimeSlotsService.deleteDeliveryTimeSlot(companyId, deliveryTimeSlotId)

    super( 'name', Constants.localStorageKeys.deliveryCompaniesTable, deleteFunction, utilsService, snackService, dialogService)


    this.observable$ =
      of(true)
        .pipe(
          tap(() => this.paramLoading = true),
          switchMap(() => this.userReference$),
          switchMap(userReference => {
            this.userReference = userReference
            return this.deliveryTimeSlotsService.getDeliveryTimeSlots(this.userReference.companyId, this.fetchParams)
          }),
          switchMap(deliveryTimeSlots => {
            this.paramLoading = false
            this.dataSource = new MatTableDataSource<DeliveryTimeSlotData>(deliveryTimeSlots.list)
            this.entityList.push(...deliveryTimeSlots.list)
            this.numEntities = deliveryTimeSlots.num
            return of(deliveryTimeSlots.list)
          }),
          catchError((err, caught) => {
            this.paramLoading = false
            if (!err.errors.includes('403'))
              this.snackService.error('Impossibile caricare le fasce orarie');
            return EMPTY;
          })
        )

    this.subs.push(this.observable$.subscribe())

    this.displayedColumns = [
      "name",
      "action",
    ]

  }


  addDeliveryTimeSlot() {
    this.dialogService.open(GeneralDialogComponent, {
      data: {
        dialogTitle: 'CREAZIONE – Fascia Oraria',
        componentData: {companyId: this.userReference.companyId},
        component: DeliveryTimeSlotsFormComponent
      }
    })
      .afterClosed()
      .pipe(switchMap(value => value ? this.observable$ : EMPTY))
      .subscribe({
        next: () => this.snackService.success('Fascia oraria creata'),
        error: (error) => this.snackService.error(error.message),
      })
  }

  editDeliveryTimeSlot(deliveryTimeSlotId: number) {
    this.deliveryTimeSlotsService.getDeliveryTimeSlot(this.userReference.companyId, deliveryTimeSlotId)
      .subscribe(deliveryTimeSlot => {
        let readonly = !hasPermissionOnEntity(this.userReference.user, {
          accessEntity: this.accessEntities.deliveryCompanies,
          accessLevel: this.accessLevels.editor
        }, deliveryTimeSlot)
        this.dialogService.open(GeneralDialogComponent, {
          data: {
            dialogTitle: readonly ? `DETTAGLIO – ${deliveryTimeSlot.name}` : `MODIFICA – ${deliveryTimeSlot.name}`,
            componentData: {entity: deliveryTimeSlot, companyId: this.userReference.companyId, readOnly: readonly},
            component: DeliveryTimeSlotsFormComponent
          }
        })
          .afterClosed()
          .pipe(switchMap(value => value ? this.observable$ : EMPTY))
          .subscribe({
            next: () => {
              this.snackService.success('Fascia oraria aggiornata');
            },
            error: () => {
              this.snackService.success('Impossibile aggiornare la fascia oraria');
            },
          })
      })
  }

}
